import PropTypes from 'prop-types';

export const itemShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    starred: PropTypes.bool,
    position: PropTypes.number,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
});

export const checklistShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(itemShape).isRequired,
    groupId: PropTypes.string,
    sortMode: PropTypes.string,
});

export const groupShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
});
